import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, EMPTY, throwError } from 'rxjs';
import { PermissionSyncService } from '../services/permission-sync.service';

/**
 * App-level interceptor for 403 INSUFFICIENT_PERMISSIONS responses.
 *
 * `PermissionSyncService` tells the two possible causes apart by the
 * permission the response names: an administrator removed it after the app
 * loaded the user's permissions (dialog + reload, the safety net for a missed
 * WebSocket event), or the user never had it and the page asked anyway (a
 * notice naming it, and the user stays where they are).
 *
 * The error is swallowed (EMPTY) either way: pages answer a failed request
 * with their own "Er is iets misgegaan" message, which would only contradict
 * the explanation given here.
 */
export const permissionSyncInterceptor: HttpInterceptorFn = (req, next) => {
  const syncService = inject(PermissionSyncService);

  return next(req).pipe(
    catchError((error) => {
      if (
        error.status === 403 &&
        error.error?.detail?.errorCode === 'INSUFFICIENT_PERMISSIONS'
      ) {
        syncService.handleInsufficientPermissions(
          req.method,
          error.error.detail.errorMessage
        );
        return EMPTY;
      }
      return throwError(() => error);
    })
  );
};
